import React from "react"
import { StyledIbanChecker as IbanCodeChecker } from "@bufox/react-utils/components/iban-checker/iban-checker"

const IbanChecker = props => {
  return <IbanCodeChecker {...props}></IbanCodeChecker>
}

export default IbanChecker
